import { registerFunctionalComponent } from 'js/lib/components/component'
import { focusLock } from 'js/lib/focus-lock'

registerFunctionalComponent('.js-c-ui-dropdown', 'UiDropdown', initDropdown)

function initDropdown(component) {
  const trigger = component.element.querySelector('.js-c-ui-dropdown-trigger')
  const content = component.element.querySelector('.js-c-ui-dropdown-content')

  if (!trigger || !content) return

  const handleKeydown = (event) => {
    if (event.key === 'Escape' && trigger.getAttribute('aria-expanded') === 'true') {
      closeDropdown()
    }
  }

  const handleOutsideClick = (event) => {
    if (!trigger.contains(event.target) && !content.contains(event.target)) {
      closeDropdown()
    }
  }

  const handleFocusLock = (event) => focusLock(event, component.element)

  function openDropdown() {
    content.classList.replace('tw-hidden', 'tw-flex')
    trigger.setAttribute('aria-expanded', 'true')
    document.addEventListener('keydown', handleKeydown)
    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('keydown', handleFocusLock)
  }

  function closeDropdown() {
    content.classList.replace('tw-flex', 'tw-hidden')
    trigger.setAttribute('aria-expanded', 'false')
    document.removeEventListener('keydown', handleKeydown)
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('keydown', handleFocusLock)
  }

  component.useHandler(() => {
    const handleTriggerClick = () => {
      trigger.getAttribute('aria-expanded') === 'true' ? closeDropdown() : openDropdown()
    }

    trigger.addEventListener('click', handleTriggerClick)

    return () => {
      trigger.removeEventListener('click', handleTriggerClick)
      closeDropdown()
    }
  })
}
